import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { supabase } from '@/integrations/supabase/client';
export const AuthUI = () => {
  return <div className="max-w-md w-full mx-auto p-6 bg-white rounded-lg shadow-lg">
      <h1 className="text-2xl font-semibold text-sage-800 mb-6 text-center">Welcome to AltText Generator</h1>
      <Auth supabaseClient={supabase} appearance={{
      theme: ThemeSupa,
      variables: {
        default: {
          colors: {
            brand: '#84a98c',
            brandAccent: '#52796f'
          }
        }
      }
    }} providers={[]} />
    </div>;
};